import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import PropertyCommons from '../commons/property.model';

@Component
export default class InputTextComponent extends mixins(PropertyCommons) {
  @Prop({ required: true })
  public value!: string;

  @Prop({ required: false, default: 'text' })
  type: string;

  @Prop({ required: false, default: false })
  public lowerCase: boolean;

  get text(): string {
    return this.value;
  }

  set text(newValue: string) {
    this.$emit('input', newValue);
  }

  cambio(e) {
    this.$emit('change', e);
  }

  keyup(e) {
    this.$emit('keyup', e);
  }

  blur(e) {
    this.$emit('blur', e);
  }

  formatter(value) {
    return this.lowerCase ? value.toLowerCase() : value;
  }
}
